import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "utils/axios/axiosBaseQuery";
import { invalidateAllClientsListing } from "utils/common";

const apiTags = ["AssessmentStepGoals", "AssessmentStepTracking", "AssessmentStepFeedback"];

export const assessmentTreatmentPlanApi = createApi({
  reducerPath: 'assessmentTreatmentPlanApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/client",
  }),
  tagTypes: apiTags,
  endpoints: (builder) => ({
    /**
     * Get goals step detail
     */
    getGoalsStepDetail: builder.query({
      query: ({ assessmentId, clientId, clientType }) => ({
        method: "GET",
        url: `/${clientType}/assesment/goals/${assessmentId}/${clientId}`
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["AssessmentStepGoals"]
    }),

    /**
     * Submit goals step
     */
    submitGoalsStep: builder.mutation({
      query: ({ assessmentAssignedId, data, clientType }) => ({
        method: "PUT",
        url: `/${clientType}/assesment-submit/goal/${assessmentAssignedId}`,
        data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      // invalidatesTags: ["AssessmentStepTracking", "AssessmentStepGoals"]
    }),

    /**
     * Get tracking step detail
     */
    getTrackingStepDetail: builder.query({
      query: ({ assessmentId, clientId, clientType }) => ({
        method: "GET",
        url: `/${clientType}/assesment/tracking/${assessmentId}/${clientId}`
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["AssessmentStepTracking"]
    }),

    /**
     * Submit tracking step
     */
    submitTrackingStep: builder.mutation({
      query: ({ assessmentAssignedId, data, clientType }) => ({
        method: "PUT",
        url: `/${clientType}/assesment-submit/tracking/${assessmentAssignedId}`,
        data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      // invalidatesTags: ["AssessmentStepTracking"]
    }),

    /**
     * Get feedback step detail
     */
    getFeedbackStepDetail: builder.query({
      query: ({ assessmentId, clientId, clientType }) => ({
        method: "GET",
        url: `/${clientType}/assesment/feedback/${assessmentId}/${clientId}`
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["AssessmentStepFeedback"]
    }),

    /**
     * Submit feedback step
     */
    submitFeedbackStep: builder.mutation({
      query: ({ assessmentAssignedId, data, clientType }) => ({
        method: "PUT",
        url: `/${clientType}/assesment-submit/feedback/${assessmentAssignedId}`,
        data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      // invalidatesTags: ["AssessmentStepFeedback"]
    }),

    /**
     * submit report
     */
    submitReport: builder.mutation({
      query: ({ assessmentAssignedId, data, clientType }) => ({
        method: "PUT",
        url: `/${clientType}/assesment-submit/preview/${assessmentAssignedId}`,
        data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        invalidateAllClientsListing(queryFulfilled, dispatch);
      },
    }),
  })
})

export const {
  useGetGoalsStepDetailQuery,
  useSubmitGoalsStepMutation,
  useGetTrackingStepDetailQuery,
  useSubmitTrackingStepMutation,
  useGetFeedbackStepDetailQuery,
  useSubmitFeedbackStepMutation,
  useSubmitReportMutation,
} = assessmentTreatmentPlanApi;